import React from 'react';

const DashPage : React.FC = () => {
    return (
        <div>Págine em construção</div>
    )
}

export default DashPage;